/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateIcrTouchScheduleSitesConfigData
 */
export interface UpdateIcrTouchScheduleSitesConfigData {
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateIcrTouchScheduleSitesConfigData
     */
    siteNumbers: Array<number> | null;
}

/**
 * Check if a given object implements the UpdateIcrTouchScheduleSitesConfigData interface.
 */
export function instanceOfUpdateIcrTouchScheduleSitesConfigData(value: object): value is UpdateIcrTouchScheduleSitesConfigData {
    if (!('siteNumbers' in value) || value['siteNumbers'] === undefined) return false;
    return true;
}

export function UpdateIcrTouchScheduleSitesConfigDataFromJSON(json: any): UpdateIcrTouchScheduleSitesConfigData {
    return UpdateIcrTouchScheduleSitesConfigDataFromJSONTyped(json, false);
}

export function UpdateIcrTouchScheduleSitesConfigDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateIcrTouchScheduleSitesConfigData {
    if (json == null) {
        return json;
    }
    return {
        
        'siteNumbers': json['siteNumbers'] == null ? null : json['siteNumbers'],
    };
}

  export function UpdateIcrTouchScheduleSitesConfigDataToJSON(json: any): UpdateIcrTouchScheduleSitesConfigData {
      return UpdateIcrTouchScheduleSitesConfigDataToJSONTyped(json, false);
  }

  export function UpdateIcrTouchScheduleSitesConfigDataToJSONTyped(value?: UpdateIcrTouchScheduleSitesConfigData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'siteNumbers': value['siteNumbers'],
    };
}

